var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "modal fade show",
      attrs: {
        id: "moveCurrentMtpWarningModal",
        "aria-hidden": "true",
        "aria-labelledby": "exampleModalLabel",
        "data-backdrop": "static",
        role: "dialog",
        tabindex: "-1",
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "modal-dialog",
          attrs: {
            role: "document",
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "modal-content",
            },
            [
              _c(
                "div",
                {
                  staticClass: "modal-header",
                },
                [
                  _vm._m(0),
                  _c(
                    "button",
                    {
                      staticClass: "close",
                      attrs: {
                        "aria-label": "Close",
                        "data-dismiss": "modal",
                        type: "button",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.onClickButton()
                        },
                      },
                    },
                    [
                      _c(
                        "span",
                        {
                          attrs: {
                            "aria-hidden": "true",
                          },
                        },
                        [_vm._v("×")]
                      ),
                    ]
                  ),
                ]
              ),
              _vm._m(1),
              _vm.globalId !== undefined
                ? _c(
                    "div",
                    {
                      staticClass: "modal-footer pt-2",
                    },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-outline-primary",
                          attrs: {
                            "data-dismiss": "modal",
                            type: "button",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.onClickButton()
                            },
                          },
                        },
                        [
                          _vm._v(
                            " Back to MTP " + _vm._s(_vm.selectedMtpYear) + " "
                          ),
                        ]
                      ),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-primary",
                          attrs: {
                            "data-dismiss": "modal",
                            type: "button",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.emitDetails()
                            },
                          },
                        },
                        [_vm._v(" View details ")]
                      ),
                    ]
                  )
                : _c(
                    "div",
                    {
                      staticClass: "modal-footer pt-2",
                    },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-outline-primary",
                          attrs: {
                            "data-dismiss": "modal",
                            type: "button",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.onClickButton()
                            },
                          },
                        },
                        [_vm._v(" Close ")]
                      ),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-primary",
                          attrs: {
                            "data-dismiss": "modal",
                            type: "button",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.currentMtpDetails()
                            },
                          },
                        },
                        [_vm._v(" View details ")]
                      ),
                    ]
                  ),
            ]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h

    return _c(
      "div",
      {
        staticClass: "container",
      },
      [
        _c(
          "div",
          {
            staticClass: "row",
          },
          [
            _c(
              "div",
              {
                staticClass: "col-12",
              },
              [
                _c(
                  "h5",
                  {
                    staticClass: "modal-title",
                    attrs: {
                      id: "exampleModalLabel",
                    },
                  },
                  [_vm._v(" Add to current MTP ")]
                ),
              ]
            ),
          ]
        ),
      ]
    )
  } /* staticRenderFnsSpliter */,
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h

    return _c(
      "div",
      {
        staticClass: "modal-body",
      },
      [
        _c(
          "div",
          {
            staticClass: "container",
          },
          [
            _c(
              "div",
              {
                staticClass: "row",
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "col-12 pb-3",
                  },
                  [
                    _c("p", [
                      _vm._v(
                        "This budget request is already active in the current MTP period."
                      ),
                    ]),
                  ]
                ),
              ]
            ),
          ]
        ),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }